import ApiService from "@/core/services/api.service";
// action types
export const GET_ENVIO_DOCUMENTOS = "getEnvioDocumentos";
export const GET_ENVIO_DOCUMENTOS_FILTRO = "getEnvioDocumentosFitro";
export const GET_ENVIO_DOCUMENTO = "getEnvioDocumento";
export const GET_ENVIO_DOCUMENTO_DETALLES = "getEnvioDocumentoDetalles";
export const UPDATE_ENVIO_DOCUMENTO = "updateEnvioDocumento";
export const DELETE_ENVIO_DOCUMENTO = "deteleEnvioDocumento"

export const GET_ENVIO_DOCUMENTO_LISTA_NEGRAS = "getEnvioDocumentoListaNegras";
export const GET_ENVIO_DOCUMENTO_LISTA_NEGRAS_FILTRO = "getEnvioDocumentoListaNegra";
export const CREATE_ENVIO_DOCUMENTO_LISTA_NEGRA = "creategetEnvioDocumentoListaNegra";
export const UPDATE_ENVIO_DOCUMENTO_LISTA_NEGRA = "updateEnvioDocumentoListaNegra";
export const DELETE_ENVIO_DOCUMENTO_LISTA_NEGRA= "deletegetEnvioDocumentoListaNegra";
// mutation types
export const SET_ENVIO_DOCUMENTOS = "setEnvioDocumentos";
export const SET_ENVIO_DOCUMENTO = "setEnvioDocumento";

export const  SET_ENVIO_DOCUMENTO_DETALLES = "setEnvioDocumentoDetalles";
export const SET_ENVIO_DOCUMENTO_LISTA_NEGRAS = "setEnvioDocumentoListaNegras";
export const SET_ERROR = "setError";

const state = {
  errors: [],
  envioDocumentos: [],
  envioDocumentoListaNegras: [],
  envioDocumento: {},
  envioDocumentoDetalles: [],
};

const actions = {
  [GET_ENVIO_DOCUMENTOS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EnvioDocumento/v1/envioDocumentos`}, '')
        .then(({ data }) => {
          context.commit(SET_ENVIO_DOCUMENTOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ENVIO_DOCUMENTOS_FILTRO](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action:`/api/EnvioDocumento/v1/envioDocumentos/filtro/${params.rutEmpresa}/${params.desde}/${params.hasta}`}, '')
        .then(({ data }) => {
          // context.commit(SET_ENVIO_DOCUMENTO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [GET_ENVIO_DOCUMENTO](context, envioDocumentoId) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EnvioDocumento/v1/envioDocumento/${envioDocumentoId}`}, '')
        .then(({ data }) => {
          context.commit(SET_ENVIO_DOCUMENTO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [UPDATE_ENVIO_DOCUMENTO](context, envioDocumento) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/EnvioDocumento/v1/envioDocumento`}, envioDocumento)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DELETE_ENVIO_DOCUMENTO](context, envioDocumentoListaNegraId) {
    return new Promise((resolve, reject) => {
    ApiService.delete({action:`/api/EnvioDocumento/v1/envioDocumento/${envioDocumentoListaNegraId}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [GET_ENVIO_DOCUMENTO_DETALLES](context, envioDocumentoId) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EnvioDocumento/v1/envioDocumento/detalles/${envioDocumentoId}`}, '')
        .then(({ data }) => {
          // context.commit(SET_ENVIO_DOCUMENTO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },


//Llista Negra

  [GET_ENVIO_DOCUMENTO_LISTA_NEGRAS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EnvioDocumento/v1/envioDocumento/listaNegras`}, '')
        .then(({ data }) => {
          context.commit(SET_ENVIO_DOCUMENTO_LISTA_NEGRAS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ENVIO_DOCUMENTO_LISTA_NEGRAS_FILTRO](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action:`/api/EnvioDocumento/v1/envioDocumentos/filtro/${params.rutEmpresa}/${params.desde}/${params.hasta}`}, '')
        .then(({ data }) => {
          // context.commit(SET_ENVIO_DOCUMENTO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },


  [CREATE_ENVIO_DOCUMENTO_LISTA_NEGRA](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post({action:`/api/EnvioDocumento/v1/envioDocumento/listaNegra`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [UPDATE_ENVIO_DOCUMENTO_LISTA_NEGRA](context, envioDocumento) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/EnvioDocumento/v1/envioDocumento/listaNegra`}, envioDocumento)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DELETE_ENVIO_DOCUMENTO_LISTA_NEGRA](context, envioDocumentoId) {
    return new Promise((resolve, reject) => {
    ApiService.delete({action:`/api/EnvioDocumento/v1/envioDocumento/listaNegra/${envioDocumentoId}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ENVIO_DOCUMENTOS](state, data) {
    state.error = {};
    state.envioDocumentos = data;
  },
  [SET_ENVIO_DOCUMENTO_LISTA_NEGRAS](state, data) {
    state.error = {};
    state.envioDocumentoListaNegras = data;
  },
  [SET_ENVIO_DOCUMENTO](state, data) {
    state.error = {};
    state.envioDocumento = data;
  },
  [SET_ENVIO_DOCUMENTO_DETALLES](state, data) {
    state.error = {};
    state.envioDocumentoDetalle = data;
  },
};

export default {
  state,
  actions,
  mutations
};
